var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21,36.21A15.64,15.64,0,1,1,36.64,20.57,15.66,15.66,0,0,1,21,36.21ZM21,7.94A12.64,12.64,0,1,0,33.64,20.57,12.65,12.65,0,0,0,21,7.94Z",
    style: {
      fill: "#62a3ef"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.65 15.28 28.38 13 17.78 23.6 13.64 19.46 11.35 21.73 17.78 28.15 30.65 15.28",
    style: {
      fill: "#62a3ef"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIcon);
export default __webpack_public_path__ + "static/media/verify_icon.98b826d862ae535402e4c930406dc885.svg";
export { ForwardRef as ReactComponent };